const DEFAULT_TEXT = '--';
const UTILIZATION_STATUS_MAP = {
  a: '存在瓶颈，请扩容出口上行总带宽或优化同一网络下联设备数量。',
  b: '利用率高，请继续保持。',
  c:
    '利用率中等，请检查网络/硬件情况，优化相关瓶颈指标（如NAT类型、磁盘类型、文件系统，x86-CPU/内存）以进一步提高利用率。',
  d:
    '利用率低，请检查网络/硬件情况，优化相关差质指标（如NAT类型、磁盘类型、文件系统，x86-CPU/内存）以提高利用率。',
  default: DEFAULT_TEXT,
};
const REPORT_STATUS_INFO = {
  0: {
    class: 'computing',
    text: '计算中',
    result: '<span>--</span>',
  },
  1: {
    class: 'done',
    text: '已生成',
  },
  2: {
    class: 'fail',
    text: '计算失败',
    result: '<span>--</span>',
  },
};

const ISP_MAP = {
  0: '未知',
  1: '电信',
  2: '联通',
  5: '移动',
};

const DONE_STATUS = 1;
const FAIL_STATUS = 2;
export {
  DEFAULT_TEXT,
  UTILIZATION_STATUS_MAP,
  REPORT_STATUS_INFO,
  ISP_MAP,
  DONE_STATUS,
  FAIL_STATUS,
};
